"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LabelledCheckInput;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _form = require("@sharingapples/form");

function LabelledCheckInput(props) {
  var label = props.label,
      inputType = props.inputType,
      name = props.name,
      rest = (0, _objectWithoutProperties2["default"])(props, ["label", "inputType", "name"]);

  var _useFormInput = (0, _form.useFormInput)(name),
      _useFormInput2 = (0, _slicedToArray2["default"])(_useFormInput, 2),
      value = _useFormInput2[0],
      onChange = _useFormInput2[1];

  var handleChange = _react["default"].useCallback(function (e) {
    return onChange(e.target.checked);
  }, [onChange]);

  return _react["default"].createElement(_reactstrap.CustomInput, (0, _extends2["default"])({
    type: inputType,
    id: label,
    name: label,
    label: label,
    checked: value,
    onChange: handleChange
  }, rest));
}